import React from 'react';
import { ListItemButton, styled, Typography } from '@mui/material';
import { Patient } from 'types/patient';

const ListItemStyled = styled(ListItemButton)({
  alignItems: 'center',
  gap: 10,
  justifyContent: 'flex-start',
  '& svg': {
    color: '#ccc',
  },
});

interface PatientItemProps {
  option: Patient;
  selected: Patient | null;
  handleSelect(patient: Patient): void;
}

const PatientItem: React.FC<PatientItemProps> = ({ option, selected, handleSelect }) => {
  return (
    <ListItemStyled disabled={selected?.id === option.id} onClick={() => handleSelect(option)}>
      <div>
        <Typography>
          #{option.id} - {option.name}
        </Typography>
      </div>
    </ListItemStyled>
  );
};

export default PatientItem;
